export const HOME = '/';
export const MAP_PAGE = '/map';
export const MAP_PREVIEW = '/preview';
export const ENDPOINT = 'https://staging.boronstudio.com/focusapi/api/api.php?action=getTelemetryAndZonesInfoByDateRange&from=';
